import { render, staticRenderFns } from "./CartsCollection.vue?vue&type=template&id=c71a9cfa&"
import script from "./CartsCollection.vue?vue&type=script&lang=js&"
export * from "./CartsCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports